import { REPORTS } from '../constants';

/**
 * Fetch report
 * @param {object} params
 */
export const fetchReportData = params => ({
  type: REPORTS.FETCH.REQUEST,
  params,
});

/**
 * Clear filters
 * @param {Array} filters list of filters names
 */
export const clearReportFilters = (filters = []) => ({
  type: REPORTS.FILTERS.CLEAR,
  filters,
});

export const addReportData = item => ({
  type: REPORTS.ADD_DATA,
  item,
});

export const updateReportData = item => ({
  type: REPORTS.UPDATE_DATA,
  item,
});

/**
 * Get summary
 * @param {object} params
 */
export const getSummary = params => ({
  type: REPORTS.SUMMARY.REQUEST,
  params,
});



// WEBPACK FOOTER //
// ./src/store/actions/reports.actions.js